var React = require('react');

function TikTok (props) {
    return React.createElement("svg",props,[React.createElement("g",{"key":0},React.createElement("path",{"d":"M23.5,11.5c-2.9-0.9-5-3.2-5-3.2c-0.1-0.1-0.2-0.1-0.3-0.1c-0.1,0-0.2,0.2-0.2,0.2V19v0.2c0,2.5-2,4.5-4.5,4.5\n\t\ts-4.5-2-4.5-4.5s2-4.5,4.5-4.5h0.2v-0.5h-0.2c-2.8,0-5,2.3-5,5s2.3,5,5,5s5-2.3,5-5v-0.2V9.1c0.8,0.8,2.5,2.3,4.8,2.9l0.2,0.1\n\t\tl0.2-0.5L23.5,11.5z"})),React.createElement("path",{"d":"M28.2,0.9c1.8,0,3.2,1.4,3.2,3.2v24.2c0,1.8-1.4,3.2-3.2,3.2H4.1c-1.8,0-3.2-1.4-3.2-3.2V4.1c0-1.8,1.4-3.2,3.2-3.2\n\tL28.2,0.9 M28.2,0.1H4.1C1.9,0.1,0.2,1.9,0.2,4v24.2c0,2.2,1.8,3.9,3.9,3.9h24.2c2.2,0,3.9-1.8,3.9-3.9V4.1\n\tC32.2,1.9,30.4,0.1,28.2,0.1L28.2,0.1z","key":1})]);
}

TikTok.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","viewBox":"0 0 32.3 32.3","style":{"enableBackground":"new 0 0 32.3 32.3"},"xmlSpace":"preserve"};

module.exports = TikTok;

TikTok.default = TikTok;
